/**
 * @generated SignedSource<<1c32496c8cdae60ff58c84af695b00f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type superSplashLiveHomeV2LiveWidget$data = {
  readonly label: string | null | undefined;
  readonly relatedArticles: ReadonlyArray<{
    readonly entityUuid: string;
    readonly urlAlias: string;
    readonly " $fragmentSpreads": FragmentRefs<"homeSuperSplashLivePrimaryV2ContentItemContent">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "superSplashLiveHomeV2LiveWidget";
};
export type superSplashLiveHomeV2LiveWidget$key = {
  readonly " $data"?: superSplashLiveHomeV2LiveWidget$data;
  readonly " $fragmentSpreads": FragmentRefs<"superSplashLiveHomeV2LiveWidget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "superSplashLiveHomeV2LiveWidget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "relatedArticles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityUuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlAlias",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "homeSuperSplashLivePrimaryV2ContentItemContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LiveWidget",
  "abstractKey": null
};

(node as any).hash = "d96c615c46aad4d8e0366dc52e16f081";

export default node;
